const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const io = require('socket.io-client');
const Runtime = require('../../engine/runtime');
const mtof = require('mtof');

/**
 * Icon png to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
// eslint-disable-next-line max-len
//const blockIconURI = 'data:image/png;base64,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';
//const blockIconURI = 'data:image/png;base64,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'
//const blockIconURI = 'data:image/png;base64,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'
const blockIconURI = ' data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQsAAAELCAYAAADOVaNSAAAW3npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7ZpXdty6moXfMYoeAnIYDuJaPYMefn8bLMmyLQedex6vZbnKLBIE/rADWGb/3/8e8z/8ySlHE1OpueVs+RNbbL7zptrnT7v/Ohvvv8+f8Xrnvj9u3j/wvAZew/NB6c+r6xxP3y54u4cb3x839fWJr6+B3u78GjDozp436+MkOe6f4y6+Bmr7eZNbLR+nOvzzOl8n3qm8fkO5Q78Pov+bjwdiIUorcVbwfgcX7P03PjMIz2/X8fsvk+Jd470NyfASw9tMCMh3y3t7tfZjgL4P/uud+TH67+9+CL7vr+Phh1jmt6zlzz9w6fPg3xB/uHF4n5H//oO8Xf1pOa/fc1Y9Zz+r6zET0fyqKGveoqNrOHEQ8nAvy/wUfhPvy/1p/FTb7SQ5y04qcPC+OU/0j3HRLdfdcfu+TjeZYvTbF169nz7cYzUU3/wkP07JCdEdX8jYCpVcTr9NCBz273Nx977t3m+yyGWX41TvGMxxyS9/zO8+/MqPOWcqRM7W91gxL6/KZRrKnP7lLBLizitv6Qb47eeVfvuhflSqkdMU5soCux3PECO5b7UVbp4D5yVen65wpqzXAISIeycm4wIZsNmF5LKzxfviHHGsJKgzcx+iH2TApeQXk/QxhOxN8dXr3lxT3D3XJ5+9DoNNJCKFHAq5oadIVoyJ+imxUkM9hRRTSjmVVE1qqeeQIyiXc8kCuV5CiSWVXEqppZVeQ4011VxLrbXV3nwLYGBquZVWW2u9e9O5UWeszvmdI8OPMOJII48y6mijT8pnxplmnmXW2WZffoUFTKy8yqqrrb6d2SDFjjvtvMuuu+1+qLUTTjzp5FNOPe3096y9svrTzxey5l5Z8zdTOq+8Z42jppS3IZzgJClnZMxHR8aLMkBBe+XMVhejV+aUM9s8TZE8k0zKjVlOGSOFcTufjnvP3bfM/VXeTKp/lTf/p8wZpe7fyJwhdT/n7ZOsLfHcvBl7ulAxtYHu4/Ndu/G1i9T6f/r634H+g4FOXzCPk+qxhbS4EsREaZKjEMuZOucSD7xezjHK6WjhzFwtVcBIYw8+gJGSS1so27n83COueOoBNDuW8ygGHY1cfwcC43Y8R7x/mn+bjLU/Tocjn0xIekdTMufzCb1Px9pnQlz0cUL2fUrPhDSjZ0KPFPkwpV/FJ8V9xr5zmYE+EdaskUwT79Gre49J+82S9tmH1vPMqbQwPK3oaM9FT+55Wrp36pXVMUl6fOY4ZjV95ty6j2nttVNatCRKoec9UVzDceo4dgA8Lc6QF4DilCREmU8r9jbmCdPuQtN2t3JnsLhj3/Qp80229xVy93sSMB92jgoe8xNHlunX6K3MNurye+/l8zIzxT5XSR4FWXqbx+a+M0FiGtuNXAcSYZTSY9qFdfWWATC/WXsIuzEHYJGzTC0BkBoucmVq8TQ3Wd9p9QnFPNNt1hf9tOu4kcoZvhKO6MrwgEngP6WdYkDcTCSelB7kjIuNxYaeS10zJyDw+AivnlNWyrPHtkVlACZISikQKpdOMqKJH4vrW239vsKDj+/1Yr5ew5+XsPl6DX9ewuZrPf7rFjdf6/Fft7j5N+Kj8Jh/Iz4Kj/mH8Vn+I6pyO9MG/Dv3ymlQZrxF/LWCyM6oC7Tb8jB3iG2UHCFfWmmlEre6YKbiysno6Bq6oVIDDaTiDokBoeTouR+jZQZdEPWoE2DBLZbdo+uw8MqUu1vowgKhj2pjNT40OmX7eA3GWcRkTOh7xI3TOPQLPX8KPD+9xKLvk//S3cltdMKA4ENMPZixCA8ra6V6DRp2WQBPdXMHjG3dfjRXz/Y+zcHExhg0zWZQ35E4c1a17M5m1F1p3756BIlsy7G246oADlAN+2qV4/1gNQiWi2UIDrKeQApi5SZwOZ0BBhZqKJdBPia32x2dkq+uQdUk1AyIh7Wt8bi2WyoIr4Mm4xwHyNqk8MVmWE/eseFvQLfD+Cg24JeEVhDLc7dRD0s9YMveNeGSgLW0FK7MrToCCsUVzQBbuesOpza7fRseliAeAYTAaru8Votu4NfWcEvr9MMLKwdA1V0vvo+1JwNRC5oolwdQC/k4d6rVIctQWuSl6UOgNYOMoHOi2rZiOBgRZUld7U6kDBnvFNoqZREjyhp0jAu9Bx2AvJRlmkA91FT9RrjG5qgramIR9A6m2pUAymDSGRPruDtx2LmEfAYJbYjiBhugE5lJrkQiUTw2Uz+bNQa5/K17+UWR9YwVpU1roXSd1LGyUjwlDc917UzMym1rSOILRzYIWaBU9oD4DvFKjVyxwmkof4qZQ7VxB7XziiPWPXFRkUHpaD9YeLILSw1CnVp4DehnVoTpDc4fYmgmtHI6Rw9XDTprU7IjoZEH40AgQtB6dCmZzMF1iJDWmCNDzjNvgHGScgNcFKQytH9yXlg9XwcSAEZmAhWMwnm3ANWV1E/Gl9fWpdnpvgBjEZeJrpjBTPLTvRW2KJ32eVe/8Lpj3mcyox4YH0Vv6RUHJsCqY3Av0ZoLhVxH0oqUmQkR0Wm8Xu2cBw+hOh1Xtm9D60zofvVWIdJtSSqo1BdeoGAyXKxLHQS+hlWAjLQD1ExWOpWFRvEbSCSVlyBrprwYLo0ti0E2lmMwkHrWw8kMnQdt4SclULOlOVlOdFTIGsiZnlw0qUw6jerFVZUVT091SnVEwJy/sc4/aeM94BZncEWLbqGjDvSCUhuQQ/A00aRpVi0nuCQ6oBUQI6xvZ+sG/4VW6GEGigXUNWAf8QbgUxfHeLDbsmTMItatgWS0ZCNCC61DIewqLF6tDtAI/G2zdZrbgZCLRdMALukEuq1hBQ/4CxQl4I5+W6BAbQlFSDBROp6A9nGbGtuWwG+AHKHVAlxYa98B2wdF3JprgmJq7vIZqTxqjY5SVXnGMuYsrJ1S90Az9s+agwUNauuTyMO+/OokTUGNHJIFBlm3TZjcIM/YhWZHU4G3APE9CBRSE8x2OEhPaYQN4XFfmgb7fFKrcAS5B1qhL+ijHJjznkVHLTpskPuDMjwwj6EMn/YYc3/WB8ogKAF5Dagv3aLgNWo45xJZRp67gBgl6epJFj0skhVjDHQlYIumnNhqOkj7nBlfz8zTozWjXDQLB0lhIIp2mzYBadq2kSo0oBa+Sf66sgmjDU4lhH93lEK0S5EaC+5lNdQFiIPiBk6SKbAQetwBzoC3tvqoLzshcaE6gEndc/qECoEWRjwHMY100Fwt4ATeeYSNqfWuO00w6umKm7VfvHYLYN2db3yDDYMyojMokm0ieUFCpdUkpzwAK9rwJImG2biEgOSaFOFZNApQV72NoHB2KPsBzbiziXwzBXYIzL8CDhRc8xVhEqD6mEENAgXOQGqFQxuRgdyPBU0V/YGqNqZqjZtjQ+toWxJGqQP8pp65M+zMtBZAM2hfyARihTJJ1uyXG0AgJ6CdW4fhs2nGQ8fTsdQjhdRBcrjOL8vQIMNcFAE8g4oZgB5QVXtlbof3YRYNjLpaECQkr3tA7Eg6mjZTSaizRvPhOLiMFDkH9zm45wx5wlNgqBPDrFAwUhlSNLOlHDZNWeSchj+uoH0AS+vXBlIlUTE1oRCs3QkbdTBSRmnTG85rK17A2ZgRfMVMI+TVBeAg/dUi7hIPpcVFkk5bsO7EPQhXVFErIFp50IHGRURI8/dyrn4P2lK7EpvP4kt/Px9eMc+HxbaYqJglZUSBY+joZmcaApfMB/CVVZ2dP9zlKzcxz118AmoxsanXTLNCx4FmPljrQ1I7oEzNBIR1DDLLsFIASWk3IkSRwpIGad74xVcHtGtJqCNUS2sYbrgH8keiRPiZuEH2pBoDT5qZBfq3axG1SmeatQMqbpwBYIIHCHGPaFsUhDx/oxPljkn/okeLmxkxcaRXr9WxpBLzyvAm4jTIJxia1kEO4gHWCawJVkaezWDpvuAq/IAB6T33diyahkLqGN5AF+LyXTIUMDi3Eqcjm5FrTKfEtW0GdS892SyF2xFPXXuAlaKcevVYHDwG3GttDgZ0jiWCBp4CCdDvQnii4BYmOyC6mAEoXBDHL7yh6arENvA3qqid1rAlGUef44um+gx2dwNmnVWSHhlwz5dD2hbQ2dx9ZPX4lHHi79J26drE2Elo4RsWGh901cMJ2HmSLVS0fCO0MZEDEHjUUxZfut3wq6Z2wFEw5MUH5hsx/Oo1w43onbq5AzzuwMkxmp2doLZJo2MSaREsyVZnp4yL4MyDXhnczldKMrhFiuhnFurgGwoRuQ01ZUCB8luWwvHqEAiSFvbQNgFAISLi0CYrF+oFRUT7Eigayzk8FRITSxgSvIszDOhxiAUQncj9aDI6/UBPBz/ng524TT0TAi36eClL2HFozwUOsX4y+eg8FXbBn7BxwbDLIPXVOJWOLsxHOzzUcHUHKWSxQAVQOrAGapkixEcGgTaRszNbjBOoh+tERHj0IiIIvoZVV3ciXqosUWMjBymnkWimRhsiApeEFNbk8dxB7nDnhUNZBpnQwQ7KGGAh+yA30oU/Se4Ne1sXIgbHPZtH/9Ca2geoci9FWEKqtJG2DIZlrrRTmg4rmkEOiKM7zKJ1nCELCp4ULJZFrcciiYkTRaWhkNGPzBotMbYRP66W6+sxYH4k5p7hExWKv8KOlgq7b3ROl+UDcvWA6Bg6/sAKTHOKGjK3bNicBSEExXtJdJ9cCy0YW1YYyRrSO+Ck5kLOJ9dHzAb3ATNAqGiRDmvdbYYJhObdtOE39RwARwZ7M5liGSnK+G17FsaVRkEEQYQmPcXS7J97RWhu4ciGQ8L+Lxgyxwk+qM0NngJaxCAC93ouMKUzoHyo1wmSa6CQKvbL6ZFHxdH763k5DfwD7mQtUSAGRBHrCVhgYGxpH1ABKlxyGS69FZM59nQidSBNhtSYCIvbiaLMeUyK2iVo2isBASkV2KIVnaXHH2gsL8lMhgNB10blGDAWNVgoYhShW+2aNNOJaXSHIG6CLY9HwWGnGt4Yo4DAVRuAFIkyXy7mmqSNt57H7IlMyBQmTGUEZ82JnVlvKcj9iYUcAW2MvaaxLGLXkXrAHiFDlUv39WjvLpHAe8zqkTX92HZem11ImHAiVMQdCSKUEslARB7RxY2OB2QJMo42ScQQJ9aziS5RN9Ad5A3zNiwDaC+/hcCdNTdJvhfiI0v36/0vCsTcN+jnumgqalr+UdtNxW3GejaykAUUJQ4VSLQzKXBxeG55SGoo1mEFDOplX58VinYJZLrsamg+Zpior6EGOUAF0x2QROVGycv8Um8YFdSwaDwY392+pskNXwZrLPDfGUAlznBkZR97kQZO67VKFMUnQtp8OwAgcwHZKZgM5P2YWTKZjMDUuARtwq/B/0NujB0gKmo/xgaPj2Jok6T9IXAHJEZa24p2riAQkmmVJ582qC9x0JEaoL5rE3V0+majRYZsgoFKEKZ35wSd63Fs6GJUNah8YN1AiY8dwTqP99N+1aVNkPBIUPA5F1a6w4Ar6PVa9q4buB5q2A0RaJfMHVzHUEtBMX0N7VVhrGig7Q/kvCowv6FkZI7ZW5BecVcOiSQ7TyF27WmianA6eF66OwvacEvj0Ak1Nm3KZJhelN4B3TWxotCTDD89vFFTcZNlZGAa2Fx40OpJhD1ILdZ5dB6tceAVCZeMWKSbsc1g9lzgcENjg24IZu1ZAg4WvwidpaE9LK2EGpr0M+HSo09ECqaNWPW3L30YW3K/e8kECKcExSMboeVYIJestAPzZBiyfeoItf1Zr5jfoStxvzGGEXErqyMMIEpp5L1BLISWkx5hsXUYXD52hxQgeoeEImqlAG3lsupouINJfWq/Tcs50EDVE+EZQ9cv1Zk8eG04cZHECpCSFUCmpnylLDbUeeD3bmSxeu1hY5p7PoyPT6OVoSf0WICWQ6Qg2xJXp7qxGGg/6NU27Rvriye0vx5HLVlFmoP+1s6xvtbCZHBPHQM00f9pmYY5n9rL0h4st3AeRefgAWRAQYwkCjYM+MezdmDNWsLUSoo1ta4tNx8rgrCasBAEp81eBPkoZjBJT3IK4HcwDoQZakUVLUhEj8YBRz0+b3qQR8xoNcxeQETooTj0CakimZC2iIoOucMgwWllMrRHtoM+dwQTHKmAKd5PegpOz/ouCJiNFKFMms1wCKSWc7pMcdSti3QcNNtCNaPuAfFzHqa7jzbo0T4LwnrXZEAyNKuM7ZJ2Y2loNsobo36/oUXMbdi6jCyCyUNbNR7Z5RFM8lfaREMQGcRFjgg1+W5uL18WRO6XwZ3U4n3OgsCfFgrXZgnYQA4w4lj3hd63UFI1bWsv5mBHsLNNBp3WBZSqQI1+7XhbHFuX6QB/sfC4g47iT9prmIxzrk8yyKGory2ABa1B1w6FgGZCHgO5o2C5wFPBAnUCm+SC99pRX5mKNYrumANCDgeJrkd5VqBjd+22eDpbK2kWr1Xpmr2znsoKQ7AtWEw9k0AqFMkudBahaXYYWTlSBVHQ6ZAVkdDXsoQQIC21BMGlrAeSImLf0ZHgLAV29LWRjjzjVFrV1M6SS5P7L5KsWKwMNBOkIA8I5Paop7MbwkK54egQ9BXVxxkl6/lH2JMZmIgiB2Ni0lMZPa0gDhU1c1RDS0dFfBgimMi+IVL7GXjMn/TeT/qPGRAufRtm3O1xINmjMAyEBmehuLVFj/yZUh3AuFOrU+ljU9m4Gsw5+QTS29TXhNBErqCK7cHExii7Do5ziLhJHk4HZCHz7u5kDbig3IfkdJGKwI+IsQAh0JcMYdgxhIGeQ4w6ORD0DSpbu5CSUwlaAGKoDtJDBUY6g3byCCVOidpFIl64B6R+h0hwcHsaFBHogCs8Lfo4u6xtIc5F2+DJap+qYjCuUoFl6ExolapgtiyrA0rL9Za7aZ67IzBoRu5DbZce9ECL9qUC8f7ERV9E0v5EndowAz4BD51GuQZc80n6tg/FafU0h4jPIY9NeGsseLCCxEfh3kc46DBtZQHwSRsgaAzQbqO7YEEuRirS/RhGQpnrdFbTtIkFwNN0ESg5Zsh4oI3SgKpx4YcuONq10wQ7KjbumxbjNwsG99EasDgNqycwqonc7bib+xhr9JtMpSChazcAYQeEU6OIsRDlUAp+zZeYlvYX95ZOwy/gzGGcOfX4pzM5bfxgPlgaZpBUuSlOjotGoTilhRDsQ7YIZKDI0DdBjy/0KAlPQq6JLvVLZIc2F+DYQyRIlUjOo/BxW3BUoqacWQtjRBEDpRP/QOmzEEADoYO2QbsISBLLCoh9VHyBjOb1Eoj3LgVGjOvA0/Y2K1bVXziXnJdNyHp+RsjJTNOzJRAGlXc3JUicVK67Oz6SuwgU0ME0BCGyK2mTMevJE7AGu8x6AZSL6R1WWfE1FPkpWxsrU9teHCWpN/wwnHEWyQQPAJwbY49kgAlX7lJUNYLAkneWmc2NLo8pronh25DZBiX1WHgNPOuFEdqLOqMiAzJ8vHQQ1vDPu9IfXs2HA2UO7cQvp5hfJiME/r6zbj3fThhd+wIdrwv/AsUQcDk4+XEfQh1Ha8ElGoxqJEMxFpEUiARy6HsH2pyE23lfM1Xr2sO3cgz3BtbseydtuDSChkrb43lA8Dax92m59XxD4ftJQah3WubO60n9L6ZF7l4T037Is2/6TE4P1F7TQx4/s6v28vv5aWp/GzHzfcj+ecTM9yH75xEz34fsn0fMfB+yfx4x87si+0rEzO+K7CsRM78rsq9EzPyuyL4SMfP3bfn7iJm/b8vfR8z8fVv+PmLm79vylxH7sDfyVbX1y02W/w701YFIzWrm/wHt1rm9ccXB0wAAAYRpQ0NQSUNDIHByb2ZpbGUAAHicfZE9SMNAHMVfU0UtFQc7iDhkqE4WxC8ctQpFqBBqhVYdTC79giYNSYqLo+BacPBjserg4qyrg6sgCH6AODk6KbpIif9LCi1iPDjux7t7j7t3gFAvM83qGAM03TZTibiYya6KXa8IIYgeTCEiM8uYk6QkfMfXPQJ8vYvxLP9zf45eNWcxICASzzLDtIk3iKc3bYPzPnGEFWWV+Jx41KQLEj9yXfH4jXPBZYFnRsx0ap44QiwW2lhpY1Y0NeJJ4qiq6ZQvZDxWOW9x1spV1rwnf2E4p68sc53mEBJYxBIkiFBQRQll2IjRqpNiIUX7cR//oOuXyKWQqwRGjgVUoEF2/eB/8LtbKz8x7iWF40Dni+N8DANdu0Cj5jjfx47TOAGCz8CV3vJX6sDMJ+m1lhY9Avq2gYvrlqbsAZc7wMCTIZuyKwVpCvk88H5G35QF+m+B0JrXW3Mfpw9AmrpK3gAHh8BIgbLXfd7d3d7bv2ea/f0AV3JynIX3l14AAAAGYktHRAAVAHwAM7N4U68AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfkCg0HBSyzO71rAAAQ3klEQVR42u3dPYwb553H8Z/W65x1CLC0r6MDLFOkvaU6d6KKVC52DVx1xS1VBAHYiKquFNVcK25xTCmySRoBooqk9SyucRduey5MHgI2iWHSF0SBc7GvmP+sZsl5Izkk5xl+P8BClkntksOd3/yf15EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOYeh6A4pi01JPUleZKG1Z6GGf5NXVIty3MBwsKNIGhLehH6X9eS+tWe+gvP8yQ9tL/OLTy61Z7GMd+3I+mZpEnouTOOOAiLYgXAhaS2/dWTNJLkRZ2s05Zq9vjJwkMTSRfVnkah6uLziB83kNRe/N5WWfw+9L/mkjrVnroxr7dmIUWggLDYYVg0Jb2MeOjGrvJ3Tko7sb2IwJCkx0GVsVBdKC0Ipi2NJZ1GvIaLcEUybWko6dy+T7faU4dPEYTF6id++Ap9Yyd1P7jix/ybiqRxzMkfrgg6wUmbJTASqotwE6YZ+p5xoTW35w1DlcXrhaqmWe3JS3iPNUldSbOoygaExaGHxeIJN1RMh2PECRjnedCfkHByhwMjrrpYqjIstL5JeG5a1TKIC4JpS31Jl6Gf2UgKUBAWhxIY4RNDWYMjw4m9WBVIUj2hInlufz7L8P3e2J/nKc8LQiip6dSI6BNZfG9zSfW4DlcQFi5XC0NJFen2ajiypsNI0mihTyF43mmGbx8ER1d+p+FrBw7JY3vNcVXIUmDE9IdcV3tqcPoQFmUKiyx9CnO9G8mQ/NGNkxIflhtJZwmPX1V7tyM8mrb0Q8zzHtAcOSxHZX5zdoVspjztxEr4Z/Z1UvLP/Czl8SfWVElzwelDZXGIfRFYNrBq60XM42+qPQLjkBw7eOI3pNv2ct36I8ahr1FEedwhLFZ2mXLMKhwiKosyVAgTWedjaC6Cp+wjFkhHJ+eBca3PopbxeaeSnkj6atpS3zo6PT7uXNG5STOk0IZrVAeXojNuG5jJSVgUWl/+0Obpiv/uhI86d15Kk7Gid3NQllbXwj3OjYZELPXG7s2rvfgOzlCzLzxM+5jAoLLIOwyCEY6a7vZRzGgnF6o5uEpQSNLLaUsiMAiLTcOhLX849JSPxJnm4CpBQWCUQBFGQ7ryOyEJCjdcJyxp7yp9hujLaWt5Yx4QFlmM+Ric0ompKi6UfeLbE5szA4cUooPTrjRP+DicqCoaMc2PrKt1wwbVXqZ1KKCy8Nkqx0fyV4DCsapC6w1nS9LltCXPwgZUFitVGGkdZChmVTHWZnNZIjfeAZVFUoUxkz8qMuGjcaqq2HTS25kkz0bGQGUReUWK+uWo2C8m1UVx3FR7y59VTlVFGHt8FtjxDoOhKd3et4JhUrfEDXVeKN+p9CdWYbSZi3G4zZC+/CnaDwkKJw0TmiB5O5E/F6PNYT/MsOiKkQ5XDRLusLbNpuKL0PYCOJSwsBl/db3bth5UFVlcWrOkxsewfzvv4LSZfn2xbNwJ1V7078i0pZF21wk9l38rRo9PpPzNkPAv31DiHpuOeBMTFNtugiw6kfQ5a0r2a2ujIfYL1bDmR13sf+miuCv5vnYee2IbNl9wR7QShIV9mB3CoRTi+isae3xNZ5JG09by3eSxXbn2WWS4+zfcMan2ojsWpy3NVIw+pzt3k8d25d1n0eCQlsYoJijqKk7n9EP5O7h3GGJ1LyyYplvysCjoBeGZpDGh4VBY2EjHTyU9txIR7vJi/n9RF3udWGh8Y5O5ynz7h2D5xE6De+vzLOxD64pp3q75MGbm5i7nV2xqLr+TdmgXMtfVtHwrzon8CXJDp8PChk8X3xyKL6lz8wdH39PcqiVPkufgytaaNQ3j+osGFhpb2xPkmJBAhHHM59pw+D2dSDq3L01bkjWVR/Y1LvgM0bQVvpd6N6ep+GERugsVIeG2UcLVrUweKjQfyAJkbu8/fJ+a0Rav2FEBHNw7J3iNg4zNqDM7/9qFDQsLibby2TUJ+zcrSlgc3a/o/idNfXC23F/53Zee/vJFX3//epx3BRIEyHlBPo/L3/6LXn36KtNzn1j/Re5V0r0cgoIOzPJ5FFWST1vytMOZuUf3K/roqaf3P07uT337xUDfvmrr+7el3sJzYp9Jlqr9WlsYKTnaMCi6kl4TFAdTWex0DsP9T5qRQTEajeR5nmazmT3vUh899XR0v9RTLE5/9XP9cYXmVb1QYSGxwWoZJYwU7HTINKrp0W639eDBAz169Ei1Wu02MN7/+Ewn/9Yv9edy/jP94oNj/Sbj0ytFC4uu/CGb69AXO3OX0D42oHnvn5Z/5NXV1e1/z+dzjUbvcu2Dfz6P/DclcvJf/6r/UbZd53Jvk23UwWk9tMOFX6qKpG84vZwVN/N252fhd//t6f4nqw2svfdRLe8Oz0L5+Mf6989+pk9ff6lfK3owYS5/oCH3eSS5TvcO3SQI5bPzsPjf33X0w9u7F9HLy3fhcXZ2pkajcefx//tD+Zcn/efP9SP5HZg3CyH/1D6nrbTH8ho6rcmfhJX31vDYvcIMm/7967G+7jb04S+Heu8jvw+93++r2WxK0lJQvP1iUMYRkXmoShjbVzAHZKd9hsc5BEVH/gIelEPcpXkvQw1/+8NIf/qPun78aUf/+ElT9+6fLIWEJH335bW+feX83QMKPaP0eIOQqFh/BTtiHYa9jXx9/3amb1+19effdvQPZxd6/yd1vf+T+m2YfPelp7/eOLlO7Maa7UMXNiM+XjMo6vYmaXKUz7ioL+z7tzO9/aKvt243KYahgHCqzXS8RlDUCIqDDAvm1KxnYgHRd/0erutUFuxEdJi4OKzWvOhb9TAuy5taOSwsHSuh5co1+cM4rDQthxmHgICIksvmN9bZORJrRJwXdQcydm0/3IDYtBkSFRQeQYEDMZG/zGF4aLcg2CgsrLNzKHf2ZEQy7nQff1yGkrqud1LuJSwYPi2luBPhUEdCruWPYvT51Vh/nkVT0ksO38E4tBGwwaFXEbmEhe2MRVCU0/jA3/9AUofbIeZXWbQ5bIQFIUFYZOFZG3Ykf44FoyDlETfHolHS93stqU1zY0thUe2pI385etAsGao4uyBjM4dy0sytkujykW+3sljE9O/yVxZlqyaaNDl2HBY2s48l6iWRUI6X5YLw3Cpj7DIsQvtZoBySNlp2fdLdXNKFC3tGFNkme3AOxYSsMilrWX4jqU5Q7CksbCs9mh/l4sV81i7P3hxIatA/sadmiPVTsOdm+ZSpv2IuvxOTZvK+woJ+isOrLOTeHIsb+f0TVBN7riy6op+ijCYJ+0G6VFkw2lGgsKhxyEopqVp0oc9iYtUEMzELFBZN+TcSCt95rC7pBYeylE0Qqfgd2QP5U7bZDnDLNt5Wj5sMuS9qKz37bGuSviroy6YTc8c2utepdXiyCtVtbxIeaxT4NdcIimI3Q6KaJXR4us2l/goWgDkeFihvWBSpsmABmKthYe1ZNup1vAkS1zFoTcyifL5PqSbcriwaHD7n9RMeuyjA67uxaoIhUcfDohbxwVbEzlmumKd0EO77YsAEq4LZZDQk3Pn1Rv7sToKiHFXFPiuLG0kPCIpyVRaBK/nb7I05nE6J7QOwHdz3Mcp1JX+0gwlWJQuLjvx7K3jTltpiCNUl1ymjCruuKiby+yY8PpoShsVCp1OTQ1mOqmIPYUE1cSjNkIINsSHDVTypY9PuNreLKpFqwjFHOXyPOofRKZ0CVBVXYqu7w6ssUq4cY7H9XtGqin5CVVHTdu8Bw8a5B15ZRP1CPLaKg6qjWPopj29zUWCw+IugONSwsA//yv46sF+IvthVq2jmSh4urWg7HdVzSZ9Ve7qgE9Nt97bxTW1H6N9zeAslcUbklvYleSO/E5OQKIFt9Vmwx0WxTDJUFXl+ZmxMQ1hkqioqki45tIWSNo8hz0l17K5NWGR2wWEtVlWRMgKSZ1XB4i/CgrBwWDOt6sihqmCC1QHYxtDpOYe1MK6TTmDriH6y4c9gghWVxers1oZRV52xmJy1a/MMVcUmu09RTVBZbKSx8Mv6tNpTTW7eL9N17aRORlspvG6AP6eaoLLYVLASdSC/B35spS4LzXZrkGFad2edZo2FENvcERabsXH1ewnVBrbvRumjG0Ot1qk5sZBg3gRhsVWsD9mdYDLULKGq6K5Q6QVTxLvMwsQuwqLGYd6ZxJ2wba+KLKMfhAT2EhZRv4gzsblv3p6nbGpTl/SSkMC6jvbwMxs2QjLg8OdmkGHmZD/hsRv52wrUqj22uEMxKovnQZlc7ak5bckTS9k3ldqhGTMidSO/o7PPOg5kcW/bP2DaUl/+wrKJVRSLj1csMFh8tl5QNLJUAtZfMZM0Y34EihoWdQuDdkrnW0P+2D8zPXMOCsCJsFgjXAgNggKERWxA1OR3wHlBG9oqkjbNkyVX1R6bC2H3jgryOmpWSTyT9JX1c8yqPTUlfSjpqV1ND7WKuJL0maQPCQocemXRkPR5xEPX8teYeKEK5EL+asqzEoeDF3zR1ABhcTcsLiS9jjt5qr3lKeMWHA372teNfDc1kb/4zpM0YpQChEV6WHQUvbP0QP4oSpahwSA8gvuVFKmDdG6hMJK/t8dSMNgQcvD6G/b6HyetHgV26bggryNqsdnA+izSQqIiv3N0bF9Da7rMLECCEFHoz3rOlUiwwY+sSrj9c4VqwYtoWtX4FQVhcVdjnaAwHUVs5Tdt3W4eOw6dwFFhU9cam/NEhYAFVz3pOQmvgT0/QFiknCjNhav8XKvtNh23QfA440k/2uC11yyITmMef5QxMNhJDIV3tOegqGh5x6ZVRwBONwmLDTUTfv4khw7LBr+iICzeNSFO173KxmwQvEtJYZDHrlJsHATCImEb+ocrhMC+T6bZlsPixIaVgcMMC2t+JF6VrS8jzV5PpJT+jryaQV07XsBBVhZpe1icSHo5bWkYd6JY5+LDfVYdKRVQXjMvTyWNpy117D0De7HzSVn2C//VCv/kRhF7S9rGs0n7SU7k39tituWw+Dzm4UcrDJ2uekwmC5XLWP6EryEb2aBMlUVjxeefSfIi2u5plcOppP6WS/h6Hu9zjRP81Kqq4OtS0gv5i/CGNFtQpmbIqk4kvc7YjxF2biV8c0uvKykQ2is2G/JaVXsube39grDYqaH8iVfreBmqMLJejYP+j9kW2v3nKT/XW2Fkx8vxddEUgft9FtZGv5C/nmOd9Rlzu6KPFb2eIos38re79zZ4D0n9FVFVg2f9CuOEqeJdvVsPMtbyepMsFc2Q2wuiNGEROjma8oc/V10hel3tqbHwPdZZHJZ5VWtM4L3e4BAEAdLn5AZhsVpwNHR3eXaapeXbC6tMg6XqaTczelPtrT5fI2FZ/TrubPIDEBarnYxBcMRVHpGb4iQ0Geqhr3DT5XmGG/Rs2gzJ6hGBAcJi88rjwr7CnYo/XXdegZ3s4w3+fUXSNzm/1bWCCyAsok/SmvwFaJf7vhKv0BQJdsqS/Jmdi30UFWs+dei/AGFRUlahNO1kD4Ir+HPEhrsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBA/T8LOzbmCAmhGQAAAABJRU5ErkJggg==';

const PORT = 3030;
/**
 * Enum for echidna buttons
 */
const EchidnaButtons = {
    SR: 'd2',
    SL: 'd3'
};

const EchidnaAnalogPin = {
    A0: 'a0',
    A1: 'a1',
    A2: 'a2',
    A3: 'a3',
    A4: 'a4',
    A5: 'a5',
    A6: 'a6',
    A7: 'a7'
}

const EchidnaDigitalPin = {
    D2: 'd2',
    D3: 'd3',
    D4: 'd4',
    D5: 'd5',
    D6: 'd6',
    D7: 'd7',
    D8: 'd8',
    D9: 'd9',
    D10: 'd10',
    D11: 'd11',
    D12: 'd12',
    D13: 'd13',
}

const EchidnaServoPin = {
    D4: 'd4',
    D7: 'd7',
    D8: 'd8',
}

/**
 * Enum for leds color.
 * @readonly
 * @enum {string}
 */
const EchidnaLedColor = {
    RED: 'red',
    ORANGE: 'yellow',
    GREEN: 'green',
};

const EchidnaRGBPin = {
    RED: 'd9',
    GREEN: 'd5',
    BLUE: 'd6'
}

const EchidnaSwitch = {
    ON: 'on',
    OFF: 'off'
}

const EchidnaButtonStatus = {
    RELEASE: 'release',
    PRESS: 'press',
    //HOLD: 'hold'
}

const EchidnaJoystick = {
    X: 'a0',
    Y: 'a1'
}

const EchidnaAccelerometer = {
    X: 'a2',
    Y: 'a3'
}

const EchidnaLight = {
    PIN: 'a5'
}

const EchidnaTemp = {
    PIN: 'a6'
}

const EchidnaSound = {
    PIN: 'a7'
}

class Scratch3EchidnaBlocks {

    /**
     * @return {string} - the name of this extension.
     */
    static get EXTENSION_NAME() {
        return 'echidna';
    }

    /**
     * @return {string} - the ID of this extension.
     */
    static get EXTENSION_ID() {
        return 'echidna';
    }


    /**
     * @return {array} - text and values for each buttons menu element
     */
    get LED_MENU() {
        return [{
                text: "ROJO",
                value: EchidnaLedColor.RED
            },
            {
                text: "NARANJA",
                value: EchidnaLedColor.ORANGE
            },
            {
                text: "VERDE",
                value: EchidnaLedColor.GREEN
            }
        ];
    }

    get LED_COLOR_MENU() {
        return [{
                text: formatMessage({
                    id: 'echidna.red',
                    default: 'RED'

                }),
                value: EchidnaLedColor.RED
            },
            {
                text: formatMessage({
                    id: 'echidna.orange',
                    default: 'ORANGE'

                }),
                value: EchidnaLedColor.ORANGE
            },
            {
                text: formatMessage({
                    id: 'echidna.green',
                    default: 'GREEN'

                }),
                value: EchidnaLedColor.GREEN
            },
        ];
    }

    get SWICTH_MENU() {
        return [{
                text: formatMessage({
                    id: 'echidna.turnon',
                    default: 'TURN ON'

                }),
                value: EchidnaSwitch.ON
            },
            {
                text: formatMessage({
                    id: 'echidna.turnoff',
                    default: 'TURN OFF'
                }),
                value: EchidnaSwitch.OFF
            }
        ]
    }

    get BUTTONS_MENU() {
        return [{
                text: "SL",
                value: EchidnaButtons.SL
            },
            {
                text: "SR",
                value: EchidnaButtons.SR
            }
        ];
    }

    get ANALOG_INPUT_MENU() {
        return [{
                text: "A0",
                value: EchidnaAnalogPin.A0
            },
            {
                text: "A1",
                value: EchidnaAnalogPin.A1
            },
            {
                text: "A2",
                value: EchidnaAnalogPin.A2
            },
            {
                text: "A3",
                value: EchidnaAnalogPin.A3
            },
            {
                text: "A4",
                value: EchidnaAnalogPin.A4
            },
            {
                text: "A5",
                value: EchidnaAnalogPin.A5
            },
            {
                text: "A6",
                value: EchidnaAnalogPin.A6
            },
            {
                text: "A7",
                value: EchidnaAnalogPin.A7
            },

        ];
    }

    get DIGITAL_INPUT_MENU() {
        return [{
                text: "D2",
                value: EchidnaDigitalPin.D2
            },
            {
                text: "D3",
                value: EchidnaDigitalPin.D3
            },
            {
                text: "D4",
                value: EchidnaDigitalPin.D4
            },
            {
                text: "D7",
                value: EchidnaDigitalPin.D7
            },
            {
                text: "D8",
                value: EchidnaDigitalPin.D8
            },
        ]
    }

    get MKMK_MENU() {
        return [{
                text: "AO",
                value: EchidnaAnalogPin.A0
            },
            {
                text: "A1",
                value: EchidnaAnalogPin.A1
            },
            {
                text: "A2",
                value: EchidnaAnalogPin.A2
            },
            {
                text: "A3",
                value: EchidnaAnalogPin.A3
            },
            {
                text: "A4",
                value: EchidnaAnalogPin.A4
            },
            {
                text: "A5",
                value: EchidnaAnalogPin.A5
            },
            {
                text: "D2",
                value: EchidnaDigitalPin.D2
            },
            {
                text: "D3",
                value: EchidnaDigitalPin.D3
            },
        ];
    }

    get DIGITAL_OUTPUT_MENU() {
        return [

            {
                text: "D4",
                value: EchidnaDigitalPin.D4
            },
            {
                text: "D5",
                value: EchidnaDigitalPin.D5
            },
            {
                text: "D6",
                value: EchidnaDigitalPin.D6
            },
            {
                text: "D7",
                value: EchidnaDigitalPin.D7
            },
            {
                text: "D8",
                value: EchidnaDigitalPin.D8
            },
            {
                text: "D9",
                value: EchidnaDigitalPin.D9
            },
            {
                text: "D11",
                value: EchidnaDigitalPin.D11
            },
            {
                text: "D12",
                value: EchidnaDigitalPin.D12
            },
            {
                text: "D13",
                value: EchidnaDigitalPin.D13
            },
        ]
    }

    get SERVO_MENU() {
        return [

            {
                text: "D4",
                value: EchidnaServoPin.D4
            },
            {
                text: "D7",
                value: EchidnaServoPin.D7
            },
            {
                text: "D8",
                value: EchidnaServoPin.D8
            }
        ]
    }

    get BUTTON_STATUS_MENU() {
        return [{
                text: "no pulsado",
                value: EchidnaButtonStatus.RELEASE
            },
            {
                text: "pulsado",
                value: EchidnaButtonStatus.PRESS
            },
            // {
            //     text: "sostenido",
            //     value: EchidnaButtonStatus.HOLD
            // },
        ];
    }

    get JOYSTICK_MENU() {
        return [{
                text: "x",
                value: EchidnaJoystick.X
            },
            {
                text: "y",
                value: EchidnaJoystick.Y
            },
        ];
    }

    get ACCELEROMETER_MENU() {
        return [{
                text: "x",
                value: EchidnaAccelerometer.X
            },
            {
                text: "y",
                value: EchidnaAccelerometer.Y
            },
        ];
    }

    get ONOFF_MENU() {
        return [{
                text: "ON",
                value: 1
            },
            {
                text: "OFF",
                value: 0
            },
        ]
    }

    /**
     * Construct a set of Echidna blocks.
     * @param {Runtime} runtime - the Scratch 3.0 runtime.
     */
    constructor(runtime) {
        /**
         * The Scratch 3.0 runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;
        this.connectionAlertHasBeenShowed = false;

        this.buttonStatus = {
            sr: 'release',
            sl: 'release'
        };

        this.joystick = {
            x: 0,
            y: 0
        };

        this.light = {
            level: 0
        };

        this.analogIn = {
            level: 0
        };

        this.accelerometer = {
            x: 0,
            y: 0
        };

        this.digitalInputs = {};
        this.analogInputs = {};

        this.tempScale = 0.48828125;

        //this._socket = io(window.location.hostname + ':' + 3000);
        this._socket = io('http://localhost:' + PORT);

        this.runtime.on(Runtime.PROJECT_LOADED, () => {
            console.log("Entro en run start");
            this._socket.emit('reset', {});
        });

        this._socket.on("connect_error", data => {
            let defaultMessage =
                `It seems that echidnalink applicaction is not running. I need it to talk to Echidna board. Click in the EchidnaScratch button to get some help`;
            let message =
                formatMessage({
                    id: 'echidna.linkdisconnected',
                    default: defaultMessage,
                    description: 'Echidnalink is not connected'
                });
            if (!this.connectionAlertHasBeenShowed) {
                this.connectionAlertHasBeenShowed = true;
                alert(message);
            }
        })

        /////////////////////
        //this._socket.emit('digitalInput', { id: 'd3' });
        this._socket.on('digitalInputValue', data => {
            //console.log(data);
            this.digitalInputs[data.id] = {
                active: true,
                value: data.value
            }
        });

        this._socket.on('analogInputValue', (data) => {
            //console.log(data);
            this.analogInputs[data.id] = {
                active: true,
                value: data.value
            }
        })

        ////////////////////


        this._socket.on('button', data => {
            console.log('client: button event received');
            console.log(data);
            this.buttonStatus[data.name] = data.action;
            console.log(this.buttonStatus);
        })

        this._socket.on('joystick', data => {
            //console.log(data);
            this.joystick.x = data.x;
            this.joystick.y = data.y;
        });

        this._socket.on('light', data => {
            this.light.level = data.level;
        })

        this._socket.on('analog_in', data => {
            this.analogIn.level = data.value;
        })

        this._socket.on('accelerometer', data => {
            //console.log(data);
            this.accelerometer.x = data.x;
            this.accelerometer.y = data.y;
        });


        // this._socket.on('button_read', data => {
        //     console.log(data);
        // })

        // Create a new MicroBit peripheral instance
        //this._peripheral = new Echidna(this.runtime, Scratch3EchidnaBlocks.EXTENSION_ID);
    }


    getInfo() {
        return {
            id: Scratch3EchidnaBlocks.EXTENSION_ID,
            name: Scratch3EchidnaBlocks.EXTENSION_NAME,
            blockIconURI: blockIconURI,
            showStatusButton: false,
            blocks: [{
                    opcode: 'turnOnOffLed',
                    //text: "[SWITCH] el led de color [COLOR]",
                    text: formatMessage({
                        id: 'echidna.turnonled',
                        default: '[SWITCH] led [COLOR]',
                        description: 'turn on/off a colored led'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.STRING,
                            menu: 'switch',
                            defaultValue: EchidnaSwitch.RED
                        },
                        COLOR: {
                            type: ArgumentType.STRING,
                            menu: 'leds',
                            defaultValue: EchidnaLedColor.RED
                        }
                    }
                },
                // {
                //     opcode: 'turnOnOffLedExpr',
                //     //text: "[SWITCH] el led de color [COLOR]",
                //     text: formatMessage({
                //         id: 'echidna.turnonledexpr',
                //         default: 'Set led [COLOR] to [EXPR]',
                //         description: 'turn a colored led to the value of a boolean expresion '
                //     }),
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         COLOR: {
                //             type: ArgumentType.STRING,
                //             menu: 'leds',
                //             defaultValue: EchidnaLedColor.RED
                //         },
                //         EXPR: {
                //             type: ArgumentType.BOOLEAN,
                //             defaultValue: false
                //         },
                //     }
                // },
                {
                    opcode: 'controlRGB',
                    text: "led R[RED]G[GREEN]B[BLUE]",
                    blockType: BlockType.COMMAND,
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.STRING,
                            menu: 'switch',
                            defaultValue: EchidnaSwitch.RED
                        },
                        RED: {
                            type: ArgumentType.STRING,
                            defaultValue: 255
                        },
                        GREEN: {
                            type: ArgumentType.STRING,
                            defaultValue: 255
                        },
                        BLUE: {
                            type: ArgumentType.STRING,
                            defaultValue: 255
                        }
                    }
                },
                {
                    opcode: 'turnOnOffDigitalPin',
                    text: formatMessage({
                        id: 'echidna.digitalpin',
                        default: '[SWITCH] digital pin [PIN]',
                        description: 'turn on/off a digital pin'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.STRING,
                            menu: 'switch',
                            defaultValue: EchidnaSwitch.RED
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'digitalout',
                            defaultValue: EchidnaDigitalPin.D4
                        }
                    }
                },
                // {
                //     opcode: 'turnOnOffDigitalPinExpr',
                //     text: formatMessage({
                //         id: 'echidna.digitalpinexpr',
                //         default: 'set digital pin [PIN] to [EXPR]',
                //         description: 'set digital pin to a boolean value expression'
                //     }),
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'digitalout',
                //             defaultValue: EchidnaDigitalPin.D4
                //         },
                //         EXPR: {
                //             type: ArgumentType.BOOLEAN,
                //             defaultValue: false
                //         },
                //     }
                // },
                {
                    opcode: 'servoRun',
                    //text: "servo [PIN] ángulo [ANGLE]",
                    text: formatMessage({
                        id: 'echidna.servo',
                        default: 'servo [PIN] angle [ANGLE]',
                        description: 'set angle for servo control'
                    }),
                    blockType: BlockType.COMMAND,
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'servo',
                            defaultValue: EchidnaServoPin.D4
                        },
                        ANGLE: {
                            type: ArgumentType.STRING,
                            defaultValue: 90
                        }
                    }
                },
                // {
                //     opcode: 'playPiezo',
                //     text: "tocar la nota [NOTE] durante [DURATION] milisegundos",
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         NOTE: {
                //             type: ArgumentType.NOTE,
                //             defaultValue: 60
                //         },
                //         DURATION: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 1000
                //         }
                //     }
                // },
                {
                    opcode: 'readButtonReporter',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'echidna.button',
                        default: 'button [BUTTON] on?',
                        description: 'button value'
                    }),
                    arguments: {
                        BUTTON: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: EchidnaButtons.SL
                        },
                    }
                },
                {
                    opcode: 'digitalInReporter',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'echidna.digitalinput',
                        default: 'digital input [PIN] on?',
                        description: 'digital input value'
                    }),
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'digitalin',
                            defaultValue: 'd4'
                        }
                    },
                },
                {
                    opcode: 'analogInReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.analoginput',
                        default: 'analog input [PIN] reading',
                        description: 'analog input value'
                    }),
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'analogin',
                            defaultValue: 'a4'
                        }
                    },
                },
                {
                    opcode: 'accelerometerReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.accelerometer',
                        default: 'accelerometer [POS] reading',
                        description: 'accelerometer value'
                    }),
                    arguments: {
                        POS: {
                            type: ArgumentType.STRING,
                            menu: 'accelerometer',
                            defaultValue: EchidnaAccelerometer.X
                        }
                    }
                },
                {
                    opcode: 'joystickReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.joystick',
                        default: 'joystick [POS] reading',
                        description: 'joystick value'
                    }),
                    arguments: {
                        POS: {
                            type: ArgumentType.STRING,
                            menu: 'joystick',
                            defaultValue: EchidnaJoystick.X
                        }
                    }
                },
                {
                    opcode: 'lightReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.light',
                        default: 'light sensor reading',
                        description: 'light sensor value'
                    }),
                },
                {
                    opcode: 'tempReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.temperature',
                        default: 'temperature sensor (ºC) reading',
                        description: 'temperature sensor value in ºC'
                    }),
                },
                {
                    opcode: 'soundReporter',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'echidna.microphone',
                        default: 'microphone reading',
                        description: 'microphone reading'
                    }),
                },
                {
                    opcode: 'mkmkReporter',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'echidna.mkmk',
                        default: 'mkmk [PIN]?',
                        description: 'makeymakey reading'
                    }),
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'mkmk',
                            defaultValue: 'a0'
                        }
                    }
                },
                // {
                //     opcode: 'myReporter',
                //     blockType: BlockType.REPORTER,
                //     text: 'letter [LETTER_NUM] of [TEXT]',
                //     arguments: {
                //         LETTER_NUM: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '1'
                //         },
                //         TEXT: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'text'
                //         }
                //     }
                // }
            ],
            menus: {
                leds: {
                    acceptReporters: true,
                    items: this.LED_COLOR_MENU
                },
                switch: {
                    acceptReporters: true,
                    items: this.SWICTH_MENU
                },
                buttons: {
                    acceptReporters: true,
                    items: this.BUTTONS_MENU
                },
                button_status: {
                    acceptReporters: true,
                    items: this.BUTTON_STATUS_MENU
                },
                joystick: {
                    acceptReporters: true,
                    items: this.JOYSTICK_MENU
                },
                accelerometer: {
                    acceptReporters: true,
                    items: this.ACCELEROMETER_MENU
                },
                analogin: {
                    acceptReporters: true,
                    items: this.ANALOG_INPUT_MENU
                },
                digitalin: {
                    acceptReporters: true,
                    items: this.DIGITAL_INPUT_MENU
                },
                digitalout: {
                    acceptReporters: true,
                    items: this.DIGITAL_OUTPUT_MENU
                },
                servo: {
                    acceptReporters: true,
                    items: this.SERVO_MENU
                },
                mkmk: {
                    acceptReporters: true,
                    items: this.MKMK_MENU
                }
            }
        };
    }


    myReporter(args) {
        console.log(this.digitalInputs);
        console.log(this.analogInputs);
        return args.TEXT.charAt(args.LETTER_NUM);
    };

    turnOnOffLed(args, util) {
        console.log(args);
        this.sleep(5);
        if (args.SWITCH == 'on') {
            this._socket.emit('led', { name: args.COLOR, action: 'on' });
        } else {
            this._socket.emit('led', { name: args.COLOR, action: 'off' });
        }
    }

    turnOnOffLedExpr(args, util) {
        console.log(args);
        args.SWITCH = args.EXPR ? 'on' : 'off';
        this.turnOnOffLed(args)
    }

    controlRGB(args) {
        this.sleep(5);
        console.log(args);

        let pins = [];
        pins[0] = EchidnaRGBPin[args.RED];
        pins[1] = EchidnaRGBPin[args.GREEN];
        pins[2] = EchidnaRGBPin[args.BLUE];
        for (pin of pins) {
            if (this.digitalInputs[pin] && this.digitalInputs[pin].active) {
                this.digitalInputs[pin].active = false;
            }
        }


        let c = {
            red: parseInt(args.RED),
            green: parseInt(args.GREEN),
            blue: parseInt(args.BLUE)
        };
        this._socket.emit('rgb', { color: c, action: 'color' });
        //this._socket.emit('rgb', { action: 'on' });

    }


    turnOnOffDigitalPin(args) {
        this.sleep(5);
        if (this.digitalInputs[args.PIN] && this.digitalInputs[args.PIN].active) {
            this.digitalInputs[args.PIN].active = false;
        }

        if (args.SWITCH == 'on') {
            this._socket.emit('digitalOutput', { id: args.PIN, value: 1 });
        } else {
            this._socket.emit('digitalOutput', { id: args.PIN, value: 0 });
        }
    }

    turnOnOffDigitalPinExpr(args) {
        args.SWITCH = args.EXPR ? 'on' : 'off';
        this.turnOnOffDigitalPin(args)
    }

    servoRun(args) {
        this.sleep(5);

        if (this.digitalInputs[args.PIN] && this.digitalInputs[args.PIN].active) {
            this.digitalInputs[args.PIN].active = false;
        }

        console.log(args);

        this._socket.emit('servo', { pin: args.PIN, angle: args.ANGLE });
    }



    playPiezo(args) {
        console.log(args)
        this.sleep(5);
        console.log(args);
        this._socket.emit('piezo', {
            action: 'frequency',
            frequency: mtof(parseInt(args.NOTE)),
            duration: parseInt(args.DURATION)
        });
    }

    // Si temp = true, se aplica un factor de escala para calcular la temperatura
    inReporter(pin, temp = false) {
        if (this.analogInputs &&
            this.analogInputs[pin] &&
            this.analogInputs[pin].active) {
            return temp ? parseFloat(this.tempScale * this.analogInputs[pin].value).toFixed(2) :
                this.analogInputs[pin].value;
        } else {
            this._socket.emit('analogInput', { id: pin });

            let p = new Promise((resolve, reject) => {
                setTimeout(() => {
                    let val = temp ? this.tempScale * this.analogInputs[pin].value :
                        this.analogInputs[pin].value
                    resolve(val);
                }, 200);
            })
            return p;
        }
    }

    analogInReporter(args) {
        return this.inReporter(args.PIN);
    }

    joystickReporter(args) {
        return this.inReporter(args.POS);
    }

    accelerometerReporter(args) {
        return this.inReporter(args.POS);
    }

    lightReporter(args) {
        return this.inReporter(EchidnaLight.PIN);
    }

    tempReporter(args) {
        console.log(args);
        return this.inReporter(EchidnaTemp.PIN, true);

    }

    mkmkReporter(args) {
        console.log(args);
        if (args.PIN == 'd2' || args.PIN == 'd3') {
            return this.digitalInReporter(args);
        } else {
            return this.inReporter(args.PIN) > 200;
        }
    }

    soundReporter(args) {
        return this.inReporter(EchidnaSound.PIN, false);

    }

    digitalInReporter(args) {
        console.log(args);

        if (this.digitalInputs &&
            this.digitalInputs[args.PIN] &&
            this.digitalInputs[args.PIN].active) {
            console.log("directo");
            return this.digitalInputs[args.PIN].value == 1
        } else {
            this._socket.emit('digitalInput', { id: args.PIN });
            let p = new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(this.digitalInputs[args.PIN].value);
                }, 200);
            })

            // Esta línea de código (aún) es un misterio para mí
            // p es una promesa, pero al compararla con 1, donde sea
            // que se haga uso de ella, ¡se resuelve y se realiza
            // la comparación con 1! flipante la async programming con Javascript
            return p == 1;
        }
    }

    readButtonReporter(args) {
        //console.log(args);
        args['PIN'] = args['BUTTON'];
        return this.digitalInReporter(args);
    }

    wait(util) {
        if (util.stackTimerNeedsInit()) {
            console.log("en yield true");
            const duration = Math.max(0, 100);

            util.startStackTimer(duration);
            this.runtime.requestRedraw();
            util.yield();
        } else if (!util.stackTimerFinished()) {
            console.log("en yield false");
            util.yield();
        }
    }

    sleep(milliseconds) {
        const date = Date.now();
        let currentDate = null;
        do {
            currentDate = Date.now();
        } while (currentDate - date < milliseconds);
    }
}

module.exports = Scratch3EchidnaBlocks;